import React, {useEffect} from 'react';
import {Button, ButtonBase} from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import VirtualNumberSelector from "./VirtualNumberSelector";
import Utils from "../../../helpers/Utils";
import {useSelector} from "react-redux";
import {TRANSFER_TYPES} from "./index";

const KEYPAD_NUMBERS = [
    { number: '1', letters: '' },
    { number: '2', letters: 'ABC' },
    { number: '3', letters: 'DEF' },
    { number: '4', letters: 'GHI' },
    { number: '5', letters: 'JKL' },
    { number: '6', letters: 'MNO' },
    { number: '7', letters: 'PQRS' },
    { number: '8', letters: 'TUV' },
    { number: '9', letters: 'WXYZ' },
    { number: '*', letters: '' },
    { number: '0', letters: '+' },
    { number: '#', letters: '' },
];

const ALLOWED_KEYS = ['0','1','2','3','4','5','6','7','8','9','*','#'];

const DialerKeypad = ({ initiateCalling, number, setNumber, isCallTransfer = false, initiateSecondCalling, popoverInnerRef2 }) => {
    const {callEnvironment} = useSelector((state)=>(state.globalDialerV2));

    useEffect(() => {
        const handleKeyDown = (e) => {
            const activeTag = document.activeElement.tagName.toLowerCase();
            if (activeTag === 'input' || activeTag === 'textarea') return;

            const key = e.key;
            if (ALLOWED_KEYS.includes(key)) {
                setNumber(prev => prev + key);
            } else if (key === 'Backspace') {
                setNumber(prev => prev.slice(0, -1));
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    const handleInput = (e) => {
        setNumber(e.target.value);
    };

    const isDisabled = !Utils.validateMobileNumber(Utils.cleanPhoneNumber(number)) || number.length < 10 || (isCallTransfer ? !initiateSecondCalling : false);

    return (
        <>
            <div className='globalDialerKeypadTray'>
                <div className='dialNumberWrapper'>
                    <input
                        className='dialedNumber'
                        onChange={handleInput}
                        value={Utils.formatNumber(number)}
                    />
                </div>
                <div className='globalDialerKeypad'>
                    {
                        KEYPAD_NUMBERS.map((item, index) => (
                            <ButtonBase key={index} className='keypadItem' onClick={() => setNumber((prevState)=>(prevState + item.number))}>
                                <div className='keypadNumber'>{item.number}</div>
                                {item.letters && <div className='keypadLetters'>{item.letters}</div>}
                            </ButtonBase>
                        ))
                    }
                </div>

                {
                    !isCallTransfer &&
                    <Button
                        variant='contained'
                        color='primary'
                        className='callButton keypadSelect'
                        startIcon={<CallIcon />}
                        disableElevation
                        fullWidth
                        onClick={() => initiateCalling(null, callEnvironment.fromNumber, number)}
                        style={{ padding: 10 }}
                    >
                        Call
                    </Button>
                }
            </div>

            {
                !isCallTransfer ?
                    <VirtualNumberSelector
                        popoverInnerRef2={popoverInnerRef2}
                    /> :
                    <div className='footerSectionKeypad' >
                        <Button
                            className='cold'
                            variant='contained'
                            color='primary'
                            fullWidth
                            disabled={isDisabled}
                            onClick={()=> initiateSecondCalling(TRANSFER_TYPES.BLIND, Utils.cleanPhoneNumber(number))}
                        >
                            Cold Transfer
                        </Button>

                        <Button
                            className='warm'
                            variant='outlined'
                            fullWidth
                            onClick={() => initiateSecondCalling(TRANSFER_TYPES.WARM, Utils.cleanPhoneNumber(number))}
                            disabled={isDisabled}
                        >
                            Warm Transfer
                        </Button>
                    </div>
            }
        </>
        );
};

export default DialerKeypad;